// DEPENDENCIES
import React from "react";

// MUI COMPONENTS
import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";

// Time entry flags, matching BQE. Overtime and Extra Time are set by payroll.
export const FLAGS = [
	{ key: "billable", label: "Billable" },
	{ key: "overtime", label: "Overtime", locked: true },
	{ key: "extraTime", label: "Extra Time", locked: true },
	{ key: "compTime", label: "Comp Time" },
];

// A row of flag checkboxes; values holds each flag's current state
export default function FlagCheckboxes({
	values,
	onToggle,
	disabled = false,
	small = false,
	className = "",
	itemClassName = "",
}) {
	return (
		<div className={className}>
			{FLAGS.map((f) => {
				const control = (
					<FormControlLabel
						className={("teFlag " + itemClassName).trim()}
						disabled={f.locked || disabled}
						control={
							<Checkbox
								size={small ? "small" : "medium"}
								checked={!!values[f.key]}
								onChange={() => onToggle(f.key)}
							/>
						}
						label={f.label}
					/>
				);
				return f.locked ? (
					<Tooltip
						key={f.key}
						title={f.label + " is set by payroll, not here"}
						arrow
						placement="top"
					>
						{control}
					</Tooltip>
				) : (
					<React.Fragment key={f.key}>{control}</React.Fragment>
				);
			})}
		</div>
	);
}
